const ContactCta = () => <section id="call-us" className="bg-secondary-700 py-8">
    <div className="container mx-auto text-white text-center">
        <h2 className="text-white text-2xl">Keressen bizalommal</h2>
        <p className="text-sm mb-12"> Bármilyen kérdése támadt, vagy csak árajánlatot szeretne kérni egy munkával kapcsolatban, a megadott elérhetőségeim bármelyikén megtalál!</p>
        <a className="border-white border-solid border-4 px-4 py-2 font-bold" href="tel:+36703354283">Telefonálok</a>
    </div>
</section>

export default ContactCta;